'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _memberCompliance = require('./member-compliance.service');

var _memberCompliance2 = _interopRequireDefault(_memberCompliance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.admin.member-compliance-process', [_angularUiRouter2.default]).service('MemberComplianceService', _memberCompliance2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('memberComplianceProcess', {
    parent: 'admin',
    abstract: true,
    resolve: {
      processed: function processed(MemberComplianceService) {
        return MemberComplianceService.process().then(function () {
          return true;
        });
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/member-compliance-process.module.js